<template>
  <b-col class="border-right pr-5">
    <b-form @submit.prevent="onClickToRegist">
      <h4 class="py-2">
        <span class="mark-bottom">我是新會員</span>
      </h4>
      <p>請填寫以下資料後點選「我要註冊」，即可完成會員註冊。</p>
      <b-form-group id="new-username-fieldset" label-for="new-username" :invalid-feedback="UserNameInvalidFeedback" :state="UserNameState">
        <template slot="label">
          <span class="text-danger">*</span>帳號
        </template>
        <b-input-group class="mt-3">
          <template v-slot:append>
            <b-button variant="warning" @click="onClickCheckUsername">檢查</b-button>
          </template>
          <b-form-input id="new-username" v-model="username" :state="UserNameState" trim required @change="markChanged('username')"></b-form-input>
        </b-input-group>
      </b-form-group>
      <b-form-group id="new-password-fieldset" label-for="new-password" :invalid-feedback="PasswordInvalidFeedback" :state="PasswordState">
        <template slot="label">
          <span class="text-danger">*</span>密碼
        </template>
        <b-form-input id="new-password" type="password" v-model="password" :state="PasswordState" trim required @change="markChanged('password')" autocomplete="false"></b-form-input>
      </b-form-group>
      <b-form-group id="re-password-fieldset" label-for="re-new-password" :invalid-feedback="RePasswordInvalidFeedback" :state="RePasswordState">
        <template slot="label">
          <span class="text-danger">*</span>重新輸入密碼
        </template>
        <b-form-input id="re-new-password" type="password" v-model="repassword" :state="RePasswordState" trim required @change="markChanged('repassword')" autocomplete="false"></b-form-input>
      </b-form-group>
      <b-form-group id="new-name-fieldset" label="名字" label-for="new-name" :invalid-feedback="NameInvalidFeedback" :state="NameState">
        <template slot="label">
          <span class="text-danger">*</span>名字
        </template>
        <b-form-input id="new-name" v-model="name" :state="NameState" trim required @change="markChanged('name')"></b-form-input>
      </b-form-group>
      <b-form-group id="new-tel-fieldset" label="電話" label-for="new-tel" :invalid-feedback="TelInvalidFeedback" :state="TelState">
        <template slot="label">
          <span class="text-danger">*</span>電話
        </template>
        <b-form-input id="new-tel" v-model="tel" :state="TelState" trim required @change="markChanged('tel')"></b-form-input>
      </b-form-group>
      <b-form-group id="new-email-fieldset" label-for="new-email" :invalid-feedback="EmailInvalidFeedback" :state="EmailState">
        <template slot="label">
          <span class="text-danger">*</span>信箱
        </template>
        <b-form-input id="new-email" v-model="email" :state="EmailState" trim required @change="markChanged('email')"></b-form-input>
      </b-form-group>
      <b-form-group id="new-school_num-fieldset" label-for="new-school_num" :invalid-feedback="SchoolNumInvalidFeedback" :state="SchoolNumState">
        <template slot="label">
          <span class="text-danger">*</span>學號
        </template>
        <b-form-input id="new-school_num" v-model="school_num" :state="SchoolNumState" trim required @change="markChanged('school_num')"></b-form-input>
      </b-form-group>
      <b-button type="submit" block :disabled="!allValid || busy" class="btn-pur-mid">我要註冊</b-button>
    </b-form>
  </b-col>
</template>
<script>
import { EmailRegExp } from '../library/Var.js'
export default {
  data () {
    return {
      username: '',
      password: '',
      repassword: '',
      name: '',
      tel: '',
      email: '',
      school_num: '',
      checkState: 'not-check',
      changed: {},
      busy: false
    }
  },
  computed: {
    UserNameInvalidFeedback () {
      if (this.username.length === 0) {
        return '請填入帳號'
      } else if (this.username.length < 6) {
        return '帳號至少需要6位'
      } else if (this.checkState === 'not-check') {
        return '請檢查帳號是否重複'
      } else if (this.checkState === 'duplicate') {
        return '帳號重複'
      } else {
        return ''
      }
    },
    UserNameState () {
      if (!this.changed.username) return undefined
      return this.username.length >= 6 && this.checkState === 'ok'
    },
    PasswordInvalidFeedback () {
      if (this.password.length >= 6) {
        return ''
      } else if (this.password.length > 0) {
        return '密碼至少需要6位'
      } else {
        return '請填入密碼'
      }
    },
    PasswordState () {
      if (!this.changed.password) return undefined
      return this.password.length >= 6
    },
    RePasswordInvalidFeedback () {
      if (!this.PasswordState || this.password === this.repassword) {
        return ''
      } else {
        return '與密碼不同'
      }
    },
    RePasswordState () {
      if (!this.changed.repassword || !this.PasswordState) return undefined
      return this.password === this.repassword
    },
    NameInvalidFeedback () {
      if (this.name.length >= 2) {
        return ''
      } else if (this.name.length < 2) {
        return '姓名至少需要2位'
      } else {
        return '請輸入姓名'
      }
    },
    NameState () {
      if (!this.changed.name) return undefined
      return this.name.length >= 2
    },
    TelInvalidFeedback () {
      return '請填入電話'
    },
    TelState () {
      if (!this.changed.tel) return undefined
      return this.tel.length > 0
    },
    EmailInvalidFeedback () {
      if (EmailRegExp.test(this.email)) {
        return ''
      } else {
        return '信箱不符合格式'
      }
    },
    EmailState () {
      if (!this.changed.email) return undefined
      return EmailRegExp.test(this.email)
    },
    SchoolNumInvalidFeedback () {
      if (this.school_num.length) {
        return ''
      } else {
        return '請填入學號'
      }
    },
    SchoolNumState () {
      if (!this.changed.school_num) return undefined
      return this.school_num.length > 0
    },
    allValid () {
      return this.UserNameState &&
      this.PasswordState &&
      this.RePasswordState &&
      this.NameState &&
      this.TelState &&
      this.EmailState &&
      this.SchoolNumState
    }
  },
  methods: {
    async onClickToRegist () {
      if (!this.allValid || this.busy) return
      try {
        this.busy = true
        const data = {
          username: this.username,
          password: this.password,
          repassword: this.repassword,
          name: this.name,
          tel: this.tel,
          email: this.email,
          school_num: this.school_num
        }
        await this.$api.postUser(data)
        this.$emit('submit', null, {
          username: this.username,
          password: this.password
        })
      } catch (e) {
        this.$emit('submit', e)
        this.busy = false
      }
    },
    markChanged (name) {
      this.$set(this.changed, name, true)
    },
    async onClickCheckUsername () {
      const username = this.username
      try {
        await this.$api.PostCheckUsername({ username });
        this.checkState = 'ok'
      } catch (err) {
        this.checkState = 'duplicate'
      }
    }
  },
  watch: {
    username (val, old) {
      if (val !== old) {
        this.checkState = 'not-check'
      }
    }
  }
}
</script>